/**
 * REWE Digital GmbH.
 * IT-Verticals
 * zr-variant-switch-item component
 */

@use '../zr-css-icon/zr-css-icon.scss' as i;

// component name
$component: 'zr-variant-switch-item';

:host {
    flex: 1;
    cursor: pointer;
}

.#{$component}-inner {
    border: 1px solid var(--ci-neutral400);
    border-radius: 6px;
    line-height: 1.7143em;

    min-width: 120px;

    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    font-size: 1.1429em;

    font-weight: 700;
    color: var(--ci-neutral900);

    .header {
        border-top-left-radius: 6px;
        border-top-right-radius: 6px;
        display: flex;
        background: var(--ci-neutral200);
        padding: 4px 8px;
        height: 100%;

        .text {
            line-height: 1.2em;
            flex: 1;
        }
    }

    .body {
        display: flex;
        flex-direction: column;
        padding: 8px 8px 4px;

        div {
            flex: 1;
        }
    }

    .base {
        font-weight: 400;
        font-size: var(--zr-variant-switcher-item-base-font-size);
        line-height: var(--zr-variant-switcher-item-base-line-height);
        color: var(--ci-neutral800);
    }

    &.disabled {
        opacity: 0.3;
        cursor: not-allowed;
    }

    &.selected {
        border: 1px solid var(--ci-primary400);

        .header {
            background: var(--ci-primary100);
        }
    }
}

.#{$component}__icon {
    @include i.get-icon-only(badge);

    display: flex;
    justify-content: end;
}
